import SvgSpinner from '#/assets/images/icons/dual-ring.svg'
import SvgSearch from '#/assets/images/icons/search.svg'
import Button from '#/components/Button'
import cn from '#/utils/classnames'
import styles from './styles.module.css'
import type { GeoAutocompleteProps } from './types'
import GeoAutocomplete from './index'

interface Props<Multiple extends boolean> extends Pick<GeoAutocompleteProps<Multiple>, 'inputProps' | 'value' | 'multiple' | 'addressOnly' | 'excludeStreets' | 'types' | 'onChange'> {
  className?: string
  autoFocus?: boolean
  placeholder?: string
  loading?: boolean
  Icon?: React.ReactNode
  hideSearchButton?: boolean
  searchTitle?: string
  onSearch?: () => void
}

const AdvancedGeoAutocomplete = <Multiple extends boolean>({
  autoFocus,
  className,
  placeholder,
  loading,
  inputProps,
  searchTitle,
  hideSearchButton,
  Icon: SearchIcon,
  onSearch,
  ...props
}: Props<Multiple>) => {
  const Icon = SearchIcon || SvgSearch

  return (
    <div className={cn('flex border border-border rounded-xl h-[42px] bg-white', className)}>
      {/* @ts-expect-error */}
      <GeoAutocomplete
        classes={{
          root: 'flex flex-1 items-center',
          focused: cn({ '!items-start !py-0.5': props.multiple }),
          inputRoot: 'bg-white rounded-xl !py-1 px-1.5 h-full',
          input: 'placeholder:text-sm placeholder:text-black',
          endAdornment: 'px-1',
          popper: styles.popper
        }}
        inputProps={{
          autoFocus,
          placeholder,
          ...inputProps
        }}
        limitTags={1}
        {...props}
      />
      {!hideSearchButton && (
        <Button
          className='relative h-full min-w-[42px] rounded-l-none rounded-r-xl bg-gradient-to-l from-gradient-blue to-primary text-white'
          onClick={onSearch}
        >
          {searchTitle || <Icon />}
          <SvgSpinner
            className={cn('h-10 absolute inset-1/2 duration-300 -translate-x-1/2 -translate-y-1/2 opacity-100', { 'hidden opacity-0': !loading })}
          />
        </Button>
      )}
    </div>
  )
}

export default AdvancedGeoAutocomplete
